import axios from "axios";

const mockGreyColor =
  "https://cdn.shopify.com/s/files/1/0563/2737/2823/files/grey_x50.png?v=1675886730";

const GetColorSwatch = async (filename) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `{
          files(first: 2, query: "filename:${filename}") {
            edges {
              node {
                preview {
                  image {
                    url(transform: {maxHeight: 50})
                  }
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.body.data.files) {
      const files = response.data.body.data.files.edges.map((e) => e.node);
      const find = files.find((file) => {
        const url = file.preview.image.url;
        const start = url.lastIndexOf("/files/");
        const end = url.lastIndexOf("_x50");
        const sub = url.substring(start + 7, end);
        return sub === filename.replaceAll(" ", "-");
      });

      // TODO: need img refactor!!! add prefix color__<colorName> and change query.
      if (filename === "grey") {
        return mockGreyColor;
      }

      return find ? find.preview.image.url : "";
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default GetColorSwatch;
